import './src/styles/global.css';
import 'animate.css';

// Prism Code Highlight Themes
require('./src/styles/prism-coldark-dark.min.css');
